<template>
  <el-container class="view-content">
    <el-header class="header-content">
      <el-form :model="searchItem" label-width="auto" inline size="small">
        <el-form-item label="账号ID">
          <el-input v-model.trim="searchItem.merchant_id" clearable></el-input>
        </el-form-item>
        <el-form-item label="账号名">
          <el-input v-model.trim="searchItem.username" clearable></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model.trim="searchItem.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model.trim="searchItem.mobile" clearable></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model.trim="searchItem.email" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
      <el-row type="flex" justify="space-between" align="middle">
        <statistics :count-list="countList"/>
      </el-row>
    </el-header>
    <el-main class="main-content">
      <vue-table :table-data="tableData">
        <template slot="shopName" slot-scope="{row}">
          <template v-if="row.shop">
            <el-button class="black" type="text" @click="$router.push({path: '/shop/list', query: {shop_id: row.shop_id}})">
              {{row.shop.name}}
            </el-button>
          </template>
          <template v-else>-</template>
        </template>
        <template slot="openid" slot-scope="{row}">
          {{row.openid ? "是" : "否"}}
        </template>
        <template slot="actionBar">
          <el-table-column align="center" label="操作栏" :resizable="false" width="120">
            <template slot-scope="scope">
              <el-button type="text" @click="reset(scope.row)">重置密码</el-button>
              <el-button type="text" @click="remote(scope.row)">登录</el-button>
            </template>
          </el-table-column>
        </template>
      </vue-table>
    </el-main>
    <el-footer class="footer-content">
      <vue-pagination :paging-data="pagingData" @table-reload="getTableList" ref="paging"></vue-pagination>
    </el-footer>
    <reset-pwd v-if="resetPwd.visible" :dialog-data="resetPwd"/>
  </el-container>
</template>

<script>
  import {PagingData} from "@mixins"
  import Statistics from "@view/components/Statistics"
  import {adminType} from "@utils/formatList"
  import ResetPwd from "./dialog/ResetPwd"
  export default {
    name: "accountList",
    mixins: [PagingData],
    components: {Statistics,ResetPwd},
    data() {
      return {
        // 查询项
        searchItem: {
          merchant_id: "",
          username: "",
          name: "",
          mobile: "",
          email: "",
        },
        commitItem: null,
        // 统计
        countList: [
          {name: "商家总数", count: 0},
        ],
        // 表格数据
        tableData: {
          tableList: [],
          tableColumn: [
            {label: "账号ID", property: "id"},
            {label: "所属商家", property: "shopName"},
            {label: "账号", property: "username"},
            {label: "姓名", property: "name"},
            {label: "手机号", property: "mobile"},
            {label: "邮箱", property: "email"},
            // {label: "微信绑定", property: "openid"},
            {label: "账号类型", property: "is_admin", format: adminType},
            {label: "最后登录时间", property: "login_at"},
            {label: "登录次数", property: "login_count"},
          ],
          // 展开项
          hasExpand: true,
          expandLabelWidth: 120,
          expandColumn: [
            {label: "所属商家", property: "shop.name"},
            {label: "账号", property: "username"},
            {label: "姓名", property: "name"},
            {label: "手机号", property: "mobile"},
            {label: "邮箱", property: "email"},
            // {label: "微信绑定", property: "openid"},
            {label: "账号类型", property: "is_admin", format: adminType},
            {label: "最后登录时间", property: "login_at"},
            {label: "最后登录IP", property: "login_ip"},
            {label: "身份证号", property: "id_number"},
            {label: "最后登录位置", property: "login_city", formatFun: this.formatLocation},
            {label: "所属角色", property: "role.name"},
            {label: "登录次数", property: "login_count"},
          ]
        },
        resetPwd: {visible: false, title: "重置密码", row: null}
      }
    },
    methods: {
      formatLocation(row) {
        let province = row?.login_city?.province;
        let city = row?.login_city?.city;
        if (!province && !city) return "-";
        return `${province}${city ? " - " + city : ""}`;
      },
      reset(row) {
        this.resetPwd.visible = true;
        this.resetPwd.row = row;
      },
      async remote(row) {
        let newPage = window.open();
        this.drawNewPage(newPage);
        let nv = {
          shop_id: row.shop_id,
          merchant_id: row.id,
        };
        let res = await this.$Http.remoteShop(nv);
        if (res?.data) {
          let obj =  res.data || {};
          let url = obj.shop_url + "/login";
          delete obj.shop_url;
          newPage.location.href = this.getUrl(url, obj);
        } else {
          newPage.close();
        }
      },
      // 查询
      search() {
        this.commitItem = {...this.searchItem};
        this.pagingData.currentPage = 1;
        this.getTableList();
      },
      //获取表格数据
      async getTableList() {
        let nv = {
          page: this.pagingData.currentPage,
          limit: this.pagingData.pageSize,
        };
        // 添加筛选项
        this.copyObjValue(nv, this.commitItem);
        let res = await this.$Http.getShopAccountList(nv);
        if (res?.data) {
          let total = +res.data.total || 0;
          this.pagingData.total = total;
          this.countList[0].count = total;
          this.tableData.tableList = this.getArray(res.data.list);
        }
      },
    },
    created() {
      this.getTableList();
    }
  }
</script>

<style scoped>

</style>
